// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fQGov","ticket":"styles_ticket__8ePCj","description":"styles_description__mwlGF","buttonWrapper":"styles_buttonWrapper__PEEkm"};